import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=7a1cf0c2&scoped=true&lang=pug"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"
import style0 from "./Lista.vue?vue&type=style&index=0&id=7a1cf0c2&prod&lang=scss"
import style1 from "./Lista.vue?vue&type=style&index=1&id=7a1cf0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1cf0c2",
  null
  
)

export default component.exports